import script from "./fileUploadList.vue?vue&type=script&setup=true&lang=js"
export * from "./fileUploadList.vue?vue&type=script&setup=true&lang=js"

import "./fileUploadList.vue?vue&type=style&index=0&id=785f12b5&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-785f12b5"]])

export default __exports__